import React from 'react'
import { DraftBoardView } from './DraftBoard/DraftBoardView'

const DraftBoardPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  return <DraftBoardView />
}
export default DraftBoardPage
